module.exports = __webpack_public_path__ + "static/media/head.432f2ee5.png";